import { render, staticRenderFns } from "./home_news_roll.vue?vue&type=template&id=2ebdf212&scoped=true"
import script from "./home_news_roll.vue?vue&type=script&lang=js"
export * from "./home_news_roll.vue?vue&type=script&lang=js"
import style0 from "./home_news_roll.vue?vue&type=style&index=0&id=2ebdf212&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebdf212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ebdf212')) {
      api.createRecord('2ebdf212', component.options)
    } else {
      api.reload('2ebdf212', component.options)
    }
    module.hot.accept("./home_news_roll.vue?vue&type=template&id=2ebdf212&scoped=true", function () {
      api.rerender('2ebdf212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_news_roll.vue"
export default component.exports